module.exports = __webpack_public_path__ + "media/images/img_magazine3-482c70cfc9a17cd35de5ac250c7656e2.jpg";